import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  GeneratePasskeyChallengeForSignIn,
  GeneratePasskeyChallengeForSignInVariables,
} from './__generated__/useGeneratePasskeyChallenge.graphql.ts';

const GENERATE_PASSKEY_CHALLENGE = gql`
  mutation GeneratePasskeyChallengeForSignIn(
    $input: generatePasskeyChallengeForSignInInput!
  ) {
    generatePasskeyChallengeForSignIn(input: $input) {
      passkeyChallenge {
        challenge
        timeout
      }
      errors {
        message
      }
    }
  }
` as TypedDocumentNode<
  GeneratePasskeyChallengeForSignIn,
  GeneratePasskeyChallengeForSignInVariables
>;

export const useGeneratePasskeyChallenge = () => {
  const [generatePasskeyChallengeForSignIn] = useMutation(
    GENERATE_PASSKEY_CHALLENGE
  );
  return useCallback(async () => {
    const { data } = await generatePasskeyChallengeForSignIn({
      variables: {
        input: {},
      },
    });
    if (!data?.generatePasskeyChallengeForSignIn?.passkeyChallenge) {
      throw new Error('Unexpected');
    }

    return data.generatePasskeyChallengeForSignIn.passkeyChallenge.challenge;
  }, [generatePasskeyChallengeForSignIn]);
};
